import React, { useState, useContext } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import { LoginImg, logo } from "../../imagepath";
import FeatherIcon from "feather-icons-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { login, getUserDetails, sendValidationEmail } from "../../../services/userService";
import { AppContext } from "../../../services/AuthContext";
import { sendOtp } from "../../../services/otpService";
import { toast, ToastContainer } from "react-toastify";
import { loadProfilePhoto } from "../../../utils/photoCache";

const Login = () => {
  const [email, setEmail] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth } = useContext(AppContext);
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';


  const handlePasswordChange = (evnt) => setPassword(evnt.target.value);

  const togglePassword = () =>
    setPasswordType(passwordType === "password" ? "text" : "password");

  const handleResendValidation = async () => {
    try {
      const res = await sendValidationEmail(email);
      toast.success(res.message || "Doğrulama e-postası yeniden gönderildi!");
    } catch (err) {
      toast.error("E-posta gönderilirken bir hata oluştu.");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await login(email, password);

      if (!response || !response.token) {
        const errorMessage =
          response?.message || "Kullanıcı adı veya şifre hatalı.";

        // ❗️Aktif olmayan kullanıcı durumu
        if (
          errorMessage.toLowerCase().includes("aktif") ||
          errorMessage.toLowerCase().includes("onay")
        ) {
          setError({
            type: "inactive",
            message:
              "Hesabınız aktif değil. Lütfen e-posta adresinizi kontrol edin.",
          });
          return;
        }

        throw new Error(errorMessage);
      }

      // ✅ Giriş başarılıysa user details çek
      const detail = await getUserDetails(response.token);
      if (!detail || !detail.data) {
        const errorMessage =
          detail?.message || "Kullanıcı bilgisi alınırken hata oluştu.";
        throw new Error(errorMessage);
      }

      const authData = {
        token: response.token,
        id: detail.data.id,
        title: detail.data.title,
        name: detail.data.name,
        surname: detail.data.surname,
        email: detail.data.email,
        telephone: detail.data.telephone,
        address: detail.data.address,
        regdate: detail.data.regdate,
        tc: detail.data.tc,
        regstatus: detail.data.regstatus,
        mobileuser: detail.data.mobileuser,
        updatedate: detail.data.updatedate,
        rolename: detail.data.rolename,
        profileimage: detail.data.profileimage || null,
        lcppass: detail.data.lcppass || "",
      };

      // ✅ Giriş başarılı — auth set et ve yönlendir
      setAuth(authData);
      sessionStorage.setItem("auth", JSON.stringify(authData));

      if (authData.profileimage) {
        loadProfilePhoto({
          id: authData.id,
          fileName: authData.profileimage,
          token: authData.token,
        })
          .then(({ url }) => setAuth((prev) => ({ ...prev, avatarUrl: url })))
          .catch(() => { });
      }

      const encodedAuthData = encodeURIComponent(JSON.stringify(authData));
      document.cookie = `auth=${encodedAuthData}; path=/;`;

      // ✅ Rol bazlı veya önceki sayfaya yönlendirme
      const redirectPath = location.state?.from || "/profile";
      const redirectState = location.state?.autoDownload ? { autoDownload: true } : undefined;

      if (authData.rolename?.toLowerCase() === "publisher") {
        window.open(`${baseUrl}/panel/publisher`);
        navigate(redirectPath, { state: redirectState });
      } else {
        navigate(redirectPath, { state: redirectState });
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };


  var settings = {
    items: 2,
    margin: 25,
    dots: true,
    nav: true,
    navText: [
      '<i className="fas fa-arrow-left"></i>',
      '<i className="fas fa-arrow-right"></i>',
    ],
    loop: true,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      768: { items: 1 },
      1170: { items: 1 },
    },
  };

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <div className="flex-grow-1">
          <div className="container-fluid">
            <div className="row min-vh-100 justify-content-center align-items-center">
              <div className="col-12 col-sm-8 col-md-6 col-lg-4 mt-5">
                <div className="bg-light rounded-4 shadow-sm p-3 mb-4 d-flex justify-content-center">
                  <Link to="/home">
                    <img
                      src={logo}
                      className="img-fluid"
                      alt="Logo"
                      style={{ maxHeight: 50 }}
                    />
                  </Link>
                </div>

                <div className="bg-light rounded-4 shadow-sm p-4">
                  <h4 className="fw-semibold mb-2 text-center text-newdarkfume ">
                    Giriş Yap
                  </h4>
                  <hr className="mb-4 mt-0" />
                  <form onSubmit={handleLogin}>
                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">
                        E-posta
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="E-posta"
                        value={email}
                        required
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="input-block">
                      <label className="form-control-label text-darkfume text-sm">
                        Şifre
                      </label>
                      <div className="pass-group">
                        <input
                          type={passwordType}
                          onChange={handlePasswordChange}
                          value={password}
                          name="password"
                          className="form-control"
                          required
                          placeholder="Şifre"
                        />
                        <span
                          className="toggle-password feather-eye"
                          onClick={togglePassword}
                        >
                          {passwordType === "password" ? (
                            <FeatherIcon icon="eye" />
                          ) : (
                            <FeatherIcon icon="eye-off" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="forgot">
                      <span>
                        <Link className="text-blue text-sm" to="/forgot-password">
                          Şifremi Unuttum ?
                        </Link>
                      </span>
                    </div>

                    {error && (
                      <div className="mt-2 text-center">
                        {typeof error === "object" && error.type === "inactive" ? (
                          <p className="text-danger">
                            {error.message}{" "}
                            <span
                              onClick={handleResendValidation}
                              style={{
                                color: "#14A077",
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              Aktivasyon Kodunu Tekrar Gönder
                            </span>
                          </p>
                        ) : (
                          <p className="text-danger">{error.message || error}</p>
                        )}
                      </div>
                    )}

                    <div className="d-grid">
                      <button
                        className="btn btn-primary text-white"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Giriş Yapılıyor..." : "Giriş Yap"}
                      </button>
                    </div>
                  </form>

                  <div className="text-sm text-center mt-4">
                    <p className="mb-0">
                      <span className="me-2 text-darkfume">
                        Hesabınız yok mu?
                      </span>
                      <Link className="text-blue" to="/register">
                        Hesap Oluştur
                      </Link>
                    </p>
                  </div>
                </div>
              </div>

              <footer className="w-100 text-center mt-auto mb-2">
                <small className="text-secondary">
                  © 2025 Ideal Online &middot;
                  <Link
                    to="/kvkk"
                    className="text-secondary text-decoration-none mx-1"
                  >
                    KVKK
                  </Link>{" "}
                  &middot;
                  <Link
                    to="/help"
                    className="text-secondary text-decoration-none mx-1"
                  >
                    Yardım
                  </Link>
                </small>
              </footer>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Login;
